// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.feedback-message[data-v-511b3a28] {\r\n  max-height: 277px;\r\n  max-width: 594px;\n}\r\n", ""]);
// Exports
module.exports = exports;
